import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { CASES } from "./caseStudies";
import { CaseStudyDetail } from "./CaseStudyDetail";

const NavBtn = ({ dir, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        aria-label={dir === "prev" ? "Cas précédent" : "Cas suivant"}
        data-testid={`case-${dir}`}
        className="w-11 h-11 rounded-full border border-border-default text-navy inline-flex items-center justify-center transition-colors hover:bg-navy hover:text-white"
    >
        {dir === "prev" ? <ChevronLeft size={18} /> : <ChevronRight size={18} />}
    </button>
);

export const CaseStudiesCarousel = () => {
    const [idx, setIdx] = useState(0);
    const [paused, setPaused] = useState(false);
    const go = (d) => setIdx((i) => (i + d + CASES.length) % CASES.length);

    useEffect(() => {
        if (paused) return undefined;
        const t = setInterval(() => setIdx((i) => (i + 1) % CASES.length), 9000);
        return () => clearInterval(t);
    }, [paused]);

    const c = CASES[idx];
    return (
        <article
            data-testid="case-studies-carousel"
            aria-roledescription="carrousel"
            aria-label="Cas clients"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            className="bg-white border border-border-default rounded-2xl overflow-hidden"
        >
            <div key={c.key} className="animate-fade-up" aria-live="polite">
                <CaseStudyDetail c={c} />
            </div>
            <div className="flex items-center justify-between gap-3 border-t border-border-soft px-[22px] md:px-10 py-4">
                <NavBtn dir="prev" onClick={() => go(-1)} />
                <div className="flex flex-col items-center gap-1">
                    <div role="group" aria-label="Choisir un cas" className="flex gap-0">
                        {CASES.map((cc, i) => (
                            <button
                                key={cc.key}
                                type="button"
                                onClick={() => setIdx(i)}
                                aria-label={`Voir le cas ${i + 1} sur ${CASES.length}`}
                                aria-current={i === idx}
                                data-testid={`case-dot-${i}`}
                                className="w-11 h-11 flex items-center justify-center"
                            >
                                <span className={`h-1.5 rounded-[3px] transition-[width,background-color] duration-300 ${i === idx ? "w-[26px] bg-navy" : "w-2.5 bg-border-strong"}`} />
                            </button>
                        ))}
                    </div>
                    <span className="text-[13px] md:text-xs text-grey-text-soft text-center">Cas réel anonymisé · chiffres réels non retouchés</span>
                </div>
                <NavBtn dir="next" onClick={() => go(1)} />
            </div>
        </article>
    );
};
